import { LinearGradient } from "expo-linear-gradient"
import { React, useContext } from "react"
import { Platform, View } from "react-native"
import { Gesture, GestureDetector } from "react-native-gesture-handler"
import { IconButton } from "react-native-paper"
import Animated, {
    runOnJS,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from "react-native-reanimated"
import { theme } from "../../theme/theme"
import { DimensionsContext } from "../../utils/mobileUtils"

export const DiagnosticNavigationM = (props) => {
    const { style, currentIndex, data, onPressRight, onPressLeft, isCTA } =
        props
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                width:
                    Platform.OS !== "web" || dimensions?.width < 800
                        ? dimensions?.width - 40
                        : dimensions?.width / 2,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                ...style,
            }}
        >
            <IconButton
                size={32}
                icon="angle-left"
                disabled={currentIndex === 0}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                onPress={onPressLeft}
            />

            <IconButton
                size={32}
                icon="angle-right"
                disabled={currentIndex === data?.length || isCTA}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                onPress={onPressRight}
            />
        </View>
    )
}

export const SwipeableWrapper = (props) => {
    const { children, onSwipeLeft, onSwipeRight, style, colors } = props

    const translateX = useSharedValue(0)

    const swipeGesture = Gesture.Pan()
        .activeOffsetX([-15, 15])
        .onUpdate((e) => {
            'worklet'
            const maxSwipe = 50
            const newValue = Math.max(
                Math.min(e.translationX, maxSwipe),
                -maxSwipe
            )
            translateX.value = newValue
        })
        .onEnd((e) => {
            'worklet'
            const swipeThreshold = 80
            if (e.translationX > swipeThreshold && onSwipeRight) {
                runOnJS(onSwipeRight)()
            } else if (e.translationX < -swipeThreshold && onSwipeLeft) {
                runOnJS(onSwipeLeft)()
            }
            translateX.value = withTiming(0, { duration: 200 })
        })

    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: translateX.value }],
    }))

    return (
        <LinearGradient
            colors={colors}
            style={{
                flex: 1,
                width: "100%",
                height: "100%",
                overflow: "hidden",
                ...style,
            }}
        >
            <GestureDetector gesture={swipeGesture}>
                <Animated.View
                    style={[{
                        flex: 1,
                        width: "100%",
                        height: "100%",
                    }, animatedStyle]}
                >
                    {children}
                </Animated.View>
            </GestureDetector>
        </LinearGradient>
    )
}
